import { render, staticRenderFns } from "./inventory-warning.vue?vue&type=template&id=0e498c9e&scoped=true&"
import script from "./inventory-warning.vue?vue&type=script&lang=js&"
export * from "./inventory-warning.vue?vue&type=script&lang=js&"
import style0 from "./inventory-warning.vue?vue&type=style&index=0&id=0e498c9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e498c9e",
  null
  
)

export default component.exports